import { Theme } from '@mui/material';

import SynerionImageDark from 'src/assets/img/synerion-icon-dark.png';
import SynerionImageLight from 'src/assets/img/synerion-icon-light.png';

import { getAppBrandConfigs } from './brandConfig';

export const getSynerionLogoUrl = (theme: Theme) => {
  const brand = getAppBrandConfigs(theme.palette.mode);
  if (brand && brand.logoUrl) {
    return brand.logoUrl;
  }
  return theme.palette.mode === 'dark' ? SynerionImageDark : SynerionImageLight;
};
